/**
 * Time Picker controller
 * @author Ryan Gladstone
 */

function TimePickerController($scope, languageProvider, moment, translateService, timezoneService) {
  const clearDisplayTime = () => {
    $scope.displayTime = null;
    $scope.displayDay = null;
    $scope.displayDate = null;
  };

  $scope.showMeridian = timezoneService.userTimeHourFormat === 12;

  $scope.datepickerTimezone = timezoneService.userTimezone;
  // Only use US format if the locale is `en-us`
  $scope.dateFormatString = languageProvider.locale === 'en-us'
    ? 'MMM D'
    : 'D MMM';

  $scope.toggleDropdown = ($event) => {
    $event.preventDefault();
    $event.stopPropagation();

    $scope.isOpen = !$scope.isOpen;
  };

  $scope.clearTime = () => {
    $scope.time = null;
    $scope.currentTime = null;
    $scope.update({ time: 'empty', setAsDay: true });
    clearDisplayTime();
  };

  $scope.updateTime = ($event) => {
    $scope.update({ time: $scope.currentTime, setAsDay: false });
    $scope.toggleDropdown($event);
  };

  $scope.updateDay = (day) => {
    $scope.update({ time: day, setAsDay: true });
  };

  $scope.today = () => {
    $scope.update({ time: moment().startOf('day').valueOf(), setAsDay: false });
  };

  $scope.$watch('time', (time) => {
    $scope.currentTime = angular.copy($scope.time);
    if (time) {
      const displayTime = moment(time);
      $scope.displayTime = displayTime.format($scope.showMeridian ? 'h:mm a' : 'H:mm');
      $scope.displayDay = displayTime.format('ddd');
      $scope.displayDate = displayTime.format('MMM Do');
    }
  });

  $scope.getNotSetLabel = () => translateService.key($scope.label, 'TIMEPICKER_NOT_SET');
}

const ctrlArr = [
  '$scope',
  'languageProvider',
  'moment',
  'translateService',
  'timezoneService',
  TimePickerController
];

export default function (ngModule) {
  ngModule.controller('TimePickerController', ctrlArr);
}
